import React from "react";
var __jsx = React.createElement;
import PriceOfferProgressBar from "@/pages/price-offer/components/PriceOfferProgressBar";
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
import Select from "@/components/UiKit/Select/Select";
import stl from "@/pages/module-sell-trade/components/Sell_car_customer_locations.module.css";
import Input from "@/components/UiKit/Input/Input";
import { twMerge } from "tailwind-merge";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
import useBoolean from "@hooks/useBoolean";
import PriceOfferCitySearchRenderer from "@/pages/price-offer/components/PriceOfferCitySearchRenderer";
var PriceOfferInspectionUserLocation = function PriceOfferInspectionUserLocation() {
  var _helpers$getAreas;
  var _usePriceOfferContext = usePriceOfferContext(),
    helpers = _usePriceOfferContext.helpers,
    state = _usePriceOfferContext.state,
    actions = _usePriceOfferContext.actions,
    selectedCity = _usePriceOfferContext.selectedCity,
    selectedArea = _usePriceOfferContext.selectedArea,
    constants = _usePriceOfferContext.constants;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var isMobile = useIsMobile();
  var screenState = useBoolean();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pt-5"
  }, /*#__PURE__*/React.createElement(PriceOfferProgressBar, null), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary text-start text-lg font-bold"
  }, tShort("price_offer/inspection_location_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    className: "border border-gray-gainsboro border-solid rounded-lg p-4 overflow-hidden flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center rounded-full bg-[#e1ebfd] p-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--location-on-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#2885FC]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-neutral-30 text-xs font-normal leading-4"
  }, tShort("price_offer/inspection_location_subtitle", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-neutral-90 text-sm font-bold leading-6"
  }, helpers.getSelectedCityName))), /*#__PURE__*/React.createElement("div", {
    className: "text-primary text-xs font-semibold leading-6 cursor-pointer",
    role: "button",
    tabIndex: 0,
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      screenState.setTrue();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.currentTarget.click();
      }
    }
  }, tShort("price_offer/location_change_cta", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "h-px bg-gray-gainsboro"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-neutral-90 text-sm font-bold"
  }, tShort("price_offer/inspection_location_description", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
    className: stl.FormFiled,
    name: "area_id",
    topLabel: selectedArea ? t("neighborhood", {
      ns: "web_sell_trade"
    }) : false,
    type: "select",
    error: ""
    // @ts-ignore
    ,
    onChange: function onChange(event) {
      actions.changeSelectedArea(event.currentTarget.value);
    },
    value: selectedArea === null || selectedArea === void 0 ? void 0 : selectedArea.id
  }, /*#__PURE__*/React.createElement("option", {
    disabled: true,
    selected: true,
    hidden: true
  }, t("choose_area", {
    ns: "web_sell_trade"
  })), helpers === null || helpers === void 0 ? void 0 : (_helpers$getAreas = helpers.getAreas) === null || _helpers$getAreas === void 0 ? void 0 : _helpers$getAreas.map(function (area, idx) {
    return /*#__PURE__*/React.createElement("option", {
      key: area.id,
      value: area.id
    }, area.name);
  })), /*#__PURE__*/React.createElement(Input
  // @ts-ignore
  , {
    className: stl.FormFiled,
    name: "location_freetext",
    label: t("street_name_optional", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: "",
    onChange: function onChange(event) {
      actions.changeStreetName(event.currentTarget.value);
    },
    required: false,
    value: helpers.getStreetName
  })), /*#__PURE__*/React.createElement("div", {
    className: "absolute bottom-0 w-full left-0 px-4 py-6 md:relative md:p-0 md:pt-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-col gap-4 md:flex-row-reverse md:gap-3 md:justify-start"
  }, /*#__PURE__*/React.createElement("button", {
    className: twMerge("transition-colors duration-200 ease-in", "w-full p-3 bg-primary text-white rounded text-center font-bold border-none outline-none text-base md:max-w-[200px] cursor-pointer hover:bg-primary-120 transition-colors duration-200 ease-in", "disabled:bg-[#E8EFF6] disabled:text-[#92A5C1] disabled:cursor-not-allowed disabled:pointer-events-none"),
    disabled: !selectedArea,
    onClick: function onClick() {
      navigateTo(constants.inspection_date_url(state === null || state === void 0 ? void 0 : state.request_id));
    }
  }, tShort("price_offer/continue_button", {
    ns: "web_sell_trade"
  }))))), /*#__PURE__*/React.createElement(PriceOfferCitySearchRenderer, {
    screenState: screenState
  })));
};
export default PriceOfferInspectionUserLocation;